// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2gXM1","collapsed":"collapsed-21kKs","button":"button-3zR9o"};